import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../lib/api';
import { LogIn } from 'lucide-react';

export default function AdminLogin() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get('/settings/public').then(r => setSettings(r.data)).catch(() => {}); }, []);
  const logoText = settings?.logo_text || settings?.restaurant_name || 'La Contadina';
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] flex">
      {/* Left visual */}
      <div className="hidden lg:flex lg:flex-1 confirmation-image relative" style={settings?.booking_image_url ? { backgroundImage: `url("${settings.booking_image_url}")` } : {}}>
        <div className="absolute inset-0 bg-[#1C1C19]/40"></div>
        <div className="relative z-10 p-12 flex flex-col justify-between text-white w-full">
          <Link to="/" className="font-brand text-3xl tracking-tight" data-testid="login-logo-link">
            {settings?.logo_url ? <img src={settings.logo_url} alt={logoText} className="h-8 w-auto" /> : <>{logoText}<span className="text-[#EAB308]">.</span></>}
          </Link>
          <div className="max-w-md">
            <h2 className="font-display text-5xl leading-tight mb-4">Restaurant<br/>Verwaltung</h2>
            <p className="text-white/80 text-lg font-light">Reservierungen, Tische und Walk-ins in einer Oberfläche.</p>
          </div>
        </div>
      </div>

      {/* Right login */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden block mb-8 font-brand text-3xl text-[#1C1C19]" data-testid="login-back-home">
            {settings?.logo_url ? <img src={settings.logo_url} alt={logoText} className="h-8 w-auto" /> : <>{logoText}<span className="text-[#EAB308]">.</span></>}
          </Link>
          <div className="mb-10">
            <p className="text-sm uppercase tracking-[0.2em] text-[#5C5C59] mb-3">Admin-Bereich</p>
            <h1 className="font-display text-4xl md:text-5xl text-[#1C1C19] leading-tight">Anmelden</h1>
            <p className="text-[#5C5C59] mt-4 text-base">Melden Sie sich mit Ihrem Google-Konto an, um auf die Reservierungsverwaltung zuzugreifen.</p>
          </div>

          <button
            onClick={handleGoogleLogin}
            data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-3 bg-[#1C1C19] hover:bg-[#3A3A35] text-white py-4 px-6 rounded font-medium transition-colors"
          >
            <LogIn className="w-5 h-5" />
            Mit Google anmelden
          </button>

          <div className="mt-8 pt-8 border-t border-[#E5E5E0] text-sm text-[#5C5C59]">
            <p className="mb-2">Hinweis: Der erste angemeldete Nutzer erhält automatisch Admin-Rechte.</p>
            <Link to="/" className="text-[#1C1C19] underline hover:no-underline" data-testid="login-back-customer-link">Zurück zur Kundenseite</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
